import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getmissFields } from './missifelds';

@Injectable({
  providedIn: 'root'
})
export class MissingFieldsService {

  constructor(private http: HttpClient) { }
  get_missFields(data: getmissFields) {
    return this.http.post('/api/ProcessRun/GetMissingFieldRuns', data);

  }

  getMissingFieldsReport(p_id, c_id = null) {
    let u = '/api/ProcessRun/MissingFieldReport?runId=' + p_id;
    if (c_id) {
      u += '&clientId=' + c_id;
    }
    return this.http.get(u, { observe: 'response', responseType: 'blob' });
  }

}

